import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { text: String };
  static targets = ['message'];

  connect() {}

  copy() {
    navigator.clipboard
      .writeText(this.textValue)
      .then(() => {
        const originalText = this.messageTarget.innerHTML;
        this.messageTarget.innerHTML = 'Copied!';
        setTimeout(() => {
          this.messageTarget.innerHTML = originalText;
        }, 1000);
      })
      .catch((err) => {
        console.error('copy failed', err);
      });
  }
}
